module.exports = __webpack_public_path__ + "img/c56a5a7.jpg";